module.exports = __webpack_public_path__ + "static/media/journalist.1d90e5cf.jpg";